import isCountryCode from './is-country-code';

const optionalCountryCodeValidator = (val: string | undefined): boolean => {
  if (!val) return true;
  return isCountryCode(val);
};

export default optionalCountryCodeValidator;
